import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCall,
  postCall,
  deleteCall,
  getById,
  BASE_URL,
} from "../../utils/api";
import axios from "axios";
import toast from "react-hot-toast";

const initialState = {
  data: [],
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getCategories = createAsyncThunk(
  "categories/get",
  async ({ query = "", page = 1, per_page = 50 }) => {
    try {
      const response = await getCall(
        `/admin/v1/all_categories?query=${query}&page=${page}&per_page=${per_page}`,
        false
      );
      return response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getCategoryById = createAsyncThunk(
  "categories/getById",
  async (id) => {
    try {
      const response = await getById("/admin/v1/show_categories", id, false);
      return response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const addCategory = createAsyncThunk("categories/add", async (data) => {
  try {
    const response = await postCall("/admin/v1/add_categories", data);
    return response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const updateCategory = createAsyncThunk(
  "categories/update",
  async ({ id, formData }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/v1/update_categories/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(
        response.data.message || "categories updated successfully!"
      );

      return response.data;
    } catch (error) {
      toast.error("Unable to update data. Please try again later.");

      return rejectWithValue(error.response.data);
    }
  }
);


export const multipleDeleteCategory = createAsyncThunk(
  "categories/delete",
  async (id) => {
    
    try {
      await deleteCall(`/admin/v1/delete_categories?category_id=${id}`);
      return await id;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);


const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getCategoryById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCategoryById.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(getCategoryById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(addCategory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.data.push(action.payload);
      })
      .addCase(addCategory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(updateCategory.pending, (state) => {
        state.isUpdateStatus = "loading";
        state.error = null;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.isUpdateStatus = "succeeded";
        const index = state.data.data.findIndex(
          (category) => category.id === action.payload.data.id
        );
        if (index >= 0) {
          state.data.data[index] = action.payload.data;
        }
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.isUpdateStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })

      .addCase(multipleDeleteCategory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(multipleDeleteCategory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = state.data.data.filter(
          (category) => category.id !== action.payload
        );
      })
      .addCase(multipleDeleteCategory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      });
  },
});

export default categorySlice.reducer;
